export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/5d23014a563dca4f7a3a15ddbb31830f.png";